module.exports = __webpack_public_path__ + "img/long_1.7ee91a9e.jpg";